// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2cX3M","bigColWidth":"Table_bigColWidth__3D1to","biggerColWidth":"Table_biggerColWidth__jYlb4","row":"Table_row__1tjmq","col":"Table_col__1h9zc"};